import { createElement, forwardRef } from 'react'
import { mergeCss } from '../css/css.mjs';
import { splitProps } from '../helpers.mjs';
import { getFlexGridStyle } from '../patterns/flex-grid.mjs';
import { styled } from './factory.mjs';

export const FlexGrid = /* @__PURE__ */ forwardRef(function FlexGrid(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["container","columnSpacing","rowSpacing"])

const styleProps = getFlexGridStyle(patternProps)
const cssProps = { css: mergeCss(styleProps, props.css) }
const mergedProps = { ref, ...restProps, ...cssProps }

return createElement(styled.div, mergedProps)
  })